const multiTabSwitcher = {
    settings: {},
    init: function() {
        const $tabSwitcher = jQuery('.multi-tab-switcher');

        if( $tabSwitcher.length === 0 ) return;

        this.tabSwitcherHandler();
        this.tabSwitcherMobileHandler();
    },
    tabSwitcherHandler: function() {
        const $navTabsLinks = jQuery('.multi-tab-switcher .multi-tab-switcher__nav-tabs a');

        $navTabsLinks.on('click', function (e) {
            e.preventDefault();

            const $thisTabNavLinks = jQuery(this).parents('.multi-tab-switcher__nav-tabs').find('a');
            const $thisTabContent = jQuery(this).parents('.multi-tab-switcher').find('.multi-tab-switcher__tabs-content');

            $thisTabNavLinks.removeClass('active');
            $thisTabNavLinks.parent().removeClass('active');

            $thisTabContent.find('.multi-tab-switcher__tab-pane').hide().removeClass('fade show active');

            jQuery(this).addClass('active');
            jQuery(this).parent().addClass('active');
            $thisTabContent.find(jQuery(this).attr('href')).fadeIn(300).addClass('show active');
            $thisTabContent.find('video').trigger('pause');
        });
    },
    tabSwitcherMobileHandler: function() {
        jQuery('.multi-tab-switcher-accordion__card-header').click(function(){
            jQuery(this).toggleClass('active');

            const $thisTabContent = jQuery(this).next('.multi-tab-switcher-accordion__card-body');
            $thisTabContent.slideToggle(400, function() {
                if (! jQuery(this).is(':visible')) {
                    $thisTabContent.find('video').trigger('pause');
                }
            });
        });
    }
}

export default multiTabSwitcher;